import * as React from 'react';
import { PaginationNavigation, SpinnerWrapper } from "soprasteria-ui-library";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { PreventionProgramApi } from "../../../api/PreventionProgramApi";
import { useAuth } from '../../../App';
import { setMessage } from '../../../helpers/MessageHelper';
import { IPreventionProgramPatient, IPreventionProgramPatientSearchParams } from "../../../models/IPreventionProgramPatient";
import { PreventionProgramInfantsTable } from './PreventionProgramInfantsTable';
import { PreventionProgramInfantsForm } from './PreventionProgramInfantsForm';

export const PreventionProgramInfants: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new PreventionProgramApi(auth);

    const [preventionProgramInfants, setPreventionProgramInfants] = React.useState<IPreventionProgramPatient[]>();
    const [isFetchingPreventionProgramInfants, setIsFetchingPreventionProgramInfants] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const pageSize = 20;
    const [currentSearchParams, setCurrentSearchParams] = React.useState<IPreventionProgramPatientSearchParams>();

    const getPreventionProgramPatients = (searchParams: IPreventionProgramPatientSearchParams) => {
        setIsFetchingPreventionProgramInfants(true);

        searchParams.pageSize = pageSize;
        searchParams.pageNumber = searchParams.pageNumber ?? 1;
        setCurrentSearchParams(searchParams);

        api.getPreventionProgramInfants(searchParams, (response) => {
            setPreventionProgramInfants(response.data);
            setPaginationHeader(response.paginationHeader);
        }, (message) => {
            const newMessage = setMessage(message, errorMessage ?? "");
            setErrorMessage(newMessage);
        }, () => {
            setIsFetchingPreventionProgramInfants(false);
        });
    }

    const handleClickedPage = (page: number) => {
        if (currentSearchParams) {
            let searchParams = currentSearchParams;
            searchParams.pageNumber = page;
            getPreventionProgramPatients(searchParams)
        }
    }

    return (
        <SpinnerWrapper isLoading={isFetchingPreventionProgramInfants}>
            <section className="card">
                <div className="card-header">
                    <h2>Visa 0-2 åringar i kariespreventionsprogrammet</h2>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <PreventionProgramInfantsForm getPreventionProgramPatients={getPreventionProgramPatients} />
                        </div>
                    </div>
                    <section>
                        <PreventionProgramInfantsTable preventionProgramInfants={preventionProgramInfants} />
                        <PaginationNavigation
                            ariaLabel="prevention program infants pagination selector"
                            pagination={paginationHeader}
                            pageNeighbours={2}
                            selectedPage={page => handleClickedPage(page)}
                            showCount={true} />
                    </section>
                </div>
            </section>
        </SpinnerWrapper>
    )
}